export default __webpack_public_path__ + "public/images/errors/not-found@3x.png?d1a0ef01";